module.exports = __webpack_public_path__ + "static/media/santos.d246b1a1.png";